export default __webpack_public_path__ + "amandine.cc8566d.png";